// Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const EVM_ADDRESS_LENGTH = 44;
